<riege-sidepanel>
    <h2 i18n="@@filter-controls-headline">Filter</h2>

    <div class="column" *ngIf="filterByCountry">
        <riege-country-selector
            [selectedCountry]="selectedCountry"
            (countrySelected)="countryChanged($event)"></riege-country-selector>
    </div>

    <div class="column" *ngIf="filterByServices">
        <riege-service-selector
            [selectedServices]="selectedSevices"
            (servicesSelected)="servicesChanged($event)"></riege-service-selector>
    </div>

    <div class="column" *ngIf="filterBySorting">
        <riege-sort-selector
            [selectedSorting]="selectedSorting"
            (directionSelected)="sortingChanged($event)"></riege-sort-selector>
    </div>

    <div class="column">
        <button
            mat-flat-button
            type="button"
            class="riege-button margin-right--base"
            (click)="resetFilters()"
            i18n="@@button-label-reset-filter">
            Reset filter
        </button>

        <button
            mat-flat-button
            type="button"
            class="riege-button"
            (click)="setFilters()"
            i18n="@@button-label-set-filter">
            Set filter
        </button>
    </div>
</riege-sidepanel>
